import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    NgZone,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { Season, SeasonsService } from "../../student-housing/seasons/seasons.service";
import { S25Util } from "../../../util/s25-util";
import { UserprefService } from "../../../services/userpref.service";
import { S25Datefilter } from "../../s25-dateformat/s25.datefilter.service";
import { S25ItemI } from "../../../pojo/S25ItemI";

@TypeManagerDecorator("s25-ng-season-dropdown")
@Component({
    selector: "s25-ng-season-dropdown",
    template: `
        @if (this.items) {
            <s25-generic-dropdown
                [style.width]="'90%'"
                class="ngInlineBlock"
                [(chosen)]="this.chosen"
                [onSelect]="this.onSelect"
                [items]="this.items"
                [staticItems]="this.staticItems"
                [autoOpen]="this.autoOpen"
                [alwaysOpen]="this.alwaysOpen"
                [hideSearch]="this.hideSearch"
                [focusFirst]="false"
                [searchEnabled]="true"
                [apiBean]="this.apiBean"
                [placeholder]="'Select a Season'"
                [resetSelectedOnCleanup]="this.resetSelectedOnCleanup"
                (chosenChange)="onChosenChange($event)"
            >
            </s25-generic-dropdown>
            <button class="btn btn-flat c-margin-left--quarter" (click)="refresh()">
                <s25-ng-icon [type]="'refresh'"></s25-ng-icon>
            </button>
        }
    `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class S25SeasonDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() selectedSeason?: Season;
    @Output() selectedSeasonChange = new EventEmitter<Season>();

    seasons: Season[];
    dateFormat: string;

    onChosenChange(data: any) {
        super.onChosenChange(data);
        this.selectedSeason = undefined;
        let matches = this.seasons.filter((s) => s.seasonId === this.chosen!.itemId);
        if (matches.length) {
            this.selectedSeason = matches[0];
        }
        this.selectedSeasonChange.emit(this.selectedSeason);
    }

    constructor(
        private zone: NgZone,
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {
        super();
    }

    seasonToItem = (season: Season): S25ItemI => {
        return {
            itemId: season.seasonId,
            itemName:
                season.code +
                ": " +
                S25Datefilter.transform(season.housingStartDate, this.dateFormat) +
                " - " +
                S25Datefilter.transform(season.housingEndDate, this.dateFormat),
            itemDesc: season.descr,
        };
    };

    refresh() {
        S25Util.all({
            dateFormat: UserprefService.getS25Dateformat(),
            seasons: SeasonsService.getSeasons(),
        }).then((resp) => {
            this.zone.run(() => {
                this.dateFormat = resp.dateFormat;
                this.seasons = resp.seasons || [];
                if (this.selectedSeason) {
                    this.chosen = this.seasonToItem(this.selectedSeason);
                }
                this.items = this.seasons.map((s: Season) => {
                    return this.seasonToItem(s);
                });
                this.onLoad && this.onLoad();
                this.cd.detectChanges();
            });
        });
    }

    ngOnInit() {
        this.refresh();
    }
}
